import ClosablePopupContainer from "./closablePopup/ClosablePopup";

let hintComponent = ({cancelAction}) => {
    return <ClosablePopupContainer focusOnClose={true} cancelAction={cancelAction} headerText="File format hint">

      You can get example files on <a href="https://github.com/CatInBeard/heat-transfer/tree/main/fixtures/inp">github</a>.
      This files was generated by Abaqus/CAE. If github is not available, you can download <a href="fixtures/inp/13-elem.inp">13-elem.inp</a> as an example. In current version WEB CAE support only fixed temperature boundary conditions from .inp, you can set formula or uplaod table in application. Only simple triangular elements are supported. 
      
    </ClosablePopupContainer>;
}

export default hintComponent;